import script from "./CaIculusbc.vue?vue&type=script&setup=true&lang=js"
export * from "./CaIculusbc.vue?vue&type=script&setup=true&lang=js"

import "./CaIculusbc.vue?vue&type=style&index=0&id=655547b2&lang=css"

const __exports__ = script;

export default __exports__